<mat-card>
  <app-card-header
    [title]="'Agregar Estado'"
    icono="flag"
    [botonCerrar]="true"
    (cerrar)="cancelar()"
  ></app-card-header>

  <form [formGroup]="form" (ngSubmit)="confirmar()" autocomplete="off">
    <mat-card-content class="card-content-crear">
      <!-- Estado -->
      <section class="inputs-group">
        <ng-select
          [items]="data.estadosDisponibles"
          formControlName="estado"
          placeholder="Estado"
          appendTo="body"
          notFoundText="Sin resultados"
          style="width: 100%"
        ></ng-select>
      </section>

      @if (esEstadoFinalizada && data.verSucesos) {
        <!-- Categoría | Tags de suceso -->
        <section class="inputs-group">
          <ng-select
            [items]="data.categorias"
            formControlName="categoriasDeEvento"
            placeholder="Categoría de Suceso"
            [clearable]="true"
            appendTo="body"
            notFoundText="Sin resultados"
            class="campo"
          ></ng-select>

          <ng-select
            [items]="data.tags"
            formControlName="tagsDeEvento"
            placeholder="Tags de Suceso"
            [multiple]="true"
            [closeOnSelect]="false"
            appendTo="body"
            notFoundText="Sin resultados"
            class="campo"
          ></ng-select>
        </section>
      }

      @if (esEstadoFinalizada) {
        <section class="inputs-group">
          <mat-form-field class="campo">
            <mat-label>DTE / Causante</mat-label>
            <input matInput formControlName="causante" />
          </mat-form-field>
        </section>
      }

      @if (data.mostrarCamposVecino) {
        <!-- Nota predefinida -->
        <section class="inputs-group">
          <ng-select
            [items]="mensajes"
            formControlName="notaPredefinida"
            [closeOnSelect]="true"
            placeholder="Nota predefinida al vecino (opcional)"
            [bindValue]="'texto'"
            [bindLabel]="'texto'"
            loadingText="Cargando..."
            notFoundText="No se encontraron mensajes"
            appendTo="body"
            style="width: 100%"
          ></ng-select>
        </section>

        <!-- Nota vecino | Nota interna -->
        <section class="inputs-group">
          <mat-form-field class="campo">
            <mat-label>Nota al vecino (opcional)</mat-label>
            <textarea matInput rows="3" formControlName="nota"></textarea>
          </mat-form-field>

          <mat-form-field class="campo">
            <mat-label>Nota interna (opcional)</mat-label>
            <textarea
              matInput
              rows="3"
              formControlName="notaInterna"
            ></textarea>
          </mat-form-field>
        </section>
      } @else {
        <section class="inputs-group">
          <mat-form-field class="campo">
            <mat-label>Nota interna (opcional)</mat-label>
            <textarea
              matInput
              rows="3"
              formControlName="notaInterna"
            ></textarea>
          </mat-form-field>
        </section>
      }

      <!-- Imágenes -->
      <app-content-card title="Imágenes (opcional)" icon="photo_library">
        <app-upload-file
          textoBoton="Subir Imágenes"
          [allowMultiple]="true"
          [maxFiles]="4"
          [urls]="urls"
          (urlsChange)="onUrlsChange($event)"
          (loadingFile)="loadingFile = $event"
        ></app-upload-file>

        @if (urls.length) {
          <div class="preview-grid">
            @for (url of urls; track url; let i = $index) {
              <div class="preview-item">
                <img [src]="url" alt="Imagen" />
                <button
                  irxBotonIcono="imagen"
                  tamano="compacto"
                  type="button"
                  class="preview-remove"
                  tooltip="Quitar"
                  (click)="eliminarImagen(i)"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            }
          </div>
        }
      </app-content-card>
    </mat-card-content>

    <mat-card-actions class="actions-create">
      <button irxBoton="secundario" type="button" (click)="cancelar()">
        Cancelar
      </button>
      <button
        irxBoton="principal"
        type="submit"
        [disabled]="form.invalid || loadingFile"
      >
        <mat-icon>save</mat-icon>
        Guardar
      </button>
    </mat-card-actions>
  </form>
</mat-card>
